import { StatusBox } from '../StatusBox'

import { Typography } from '@percent/lemonade'
import { CheckListProps } from './CheckList.types'
import styles from './CheckList.module.scss'

export function CheckList({ checks, title }: Readonly<CheckListProps>) {
  return (
    <>
      <div className={styles.detailsHeader}>
        <Typography variant="h6">{title}</Typography>
      </div>
      <ul className={styles.complianceList} data-testid="compliance-details-list">
        {checks.map(check => (
          <li key={check.name}>
            <p>{check.name}</p>
            <StatusBox status={check.status} />
          </li>
        ))}
      </ul>
    </>
  )
}
